<template>
	<div v-if="aiSwtShow">
		<div class="fadein_bind SWT">
			<div class="box" style="width: 840px;">
				<div class="head">
					<p>{{$t('aipf')}}</p>
					<img src="@/assets/images/close_03.png" @click="back" class="close" />
				</div>
				<div class="airank">
					<div class="item">
						<p>{{$t('bencixiezuo')}}</p>
						<div class="contents on">{{aiData.text}}</div>
					</div>
					<div class="item">
						<p>{{$t('bencipf')}}</p>
						<div class="total">
							<div class="frs" style="padding-left: 20px;">
								<div class="jds">
									<div class="icon">
										<span>{{$t('neirong')}}</span>
										<img src="@/assets/images/whs_03.png" @click="showDesc('nr')"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.content/aiData.contentTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.content}}<i>/{{aiData.contentTotal}}</i></em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>{{$t('geshi')}}</span>
										<img src="@/assets/images/whs_03.png"  @click="showDesc('gs')"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.form/aiData.formTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.form}}<i>/{{aiData.formTotal}}</i></em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>{{$t('yufa')}}</span>
										<img src="@/assets/images/whs_03.png"  @click="showDesc('yf')"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.grammar/aiData.grammarTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.grammar}}<i>/{{aiData.grammarTotal}}</i></em></span>
								</div>
								<div class="jds">
									<div class="icon">
										<span>{{$t('cihui')}}</span>
										<img src="@/assets/images/whs_03.png"  @click="showDesc('ch')"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.vocabulary/aiData.vocabularyTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.vocabulary}}<i>/{{aiData.vocabularyTotal}}</i></em></span>
								</div>
								<div class="jds" v-if="aiData.spelling!=undefined&&aiData.spelling!=null">
									<div class="icon">
										<span>{{$t('pinxie')}}</span>
										<img src="@/assets/images/whs_03.png" @click="showDesc('px')"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.spelling/aiData.spellingTotal*100}%`"></div>
									</div>
									<span><em>{{aiData.spelling}}<i>/{{aiData.spellingTotal}}</i></em></span>
								</div>
							</div>
						</div>
					</div>
					<div class="item" v-if="aiData.sentsFeedbacksHtml&&aiData.sentsFeedbacksHtml!=''">
						<div class="h">
							<p>{{$t('zhinengjc')}}</p>
						</div>
						<div v-html="aiData.sentsFeedbacksHtml">
						</div>
					</div>
					<div class="item" v-if="aiData.sentsFeedbacks&&aiData.sentsFeedbacks.length">
						<div class="h">
							<p>{{$t('zhinengjc')}}</p>
						</div>
						<div class="jcs">
							<div class="lab" v-for="(item, index) in aiData.sentsFeedbacks">
								<p>{{$t('yuanju')}}:{{item.rawSent}}</p>
								<p>{{$t('zqjuzi')}}:{{item.correctedSent}}</p>
								<em v-for="(items, indexs) in item.errorPosInfos">{{$t('cwyuanyin')}}：{{items.errBaseInfo}}；{{$t('cwneirong')}}：{{items.orgChunk}}</em>
							</div>
						</div>
					</div>
					<div class="button" style="margin-top: 28px;">
						<div class="on" @click="back">{{$t('back')}}</div>
						<div @click="back">{{$t('queding')}}</div>
					</div>
				</div>
			</div>
		</div>
		<AiDesc :descFont="descFont"></AiDesc>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import { Message } from 'element-ui';
	import { Loading } from 'element-ui';
	export default {
		name: 'aiSwtShow',
		props: ['aiData'],
		data() {
			return {
				showbox: true,
				descFont: {}
			}
		},
		computed: {
			aiSwtShow() {
				return this.$store.state.aiSwtShow;
			}
		},
		methods: {
			showDesc(type){
				if(type == 'nr'){
					this.descFont = {
						title: '内容',
						desc: `4 The source text is summarised comprehensively, demonstrating full comprehension of the source text. Paraphrasing is used effectively to communicate a clear and accurate summary, and extraneous details are removed. All main ideas are correctly identified and synthesized in a concise and coherent manner. Summary flows smoothly and makes skilled use of appropriate and varied connective devices.
						</br>3 The source text is summarised adequately, demonstrating good comprehension of the source text. Paraphrasing is used, but not consistently well, and extraneous details may interfere with the clarity of the summary. Main ideas are correctly identified, with some minor omissions. Ideas are connected, but not synthesized efficiently. Summary can be followed logically and makes effective use of simple or repetitive connective devices.
						</br>2 The source text is summarised partially, demonstrating basic comprehension of the source text. There is no discernment between main points and peripheral detail. Ideas are identified, but the response relies heavily on repeating excerpts from the source text without synthesizing ideas and reformulating in own words. Repetitive or inappropriate connective devices are used to join ideas. Response can be followed with effort.
						</br>1 The response is relevant but not meaningfully summarised, demonstrating limited comprehension of the source text. The response is composed of disconnected ideas or excerpts from the source text without any context or attempt at synthesis. Main ideas are omitted or misrepresented. The response lacks coherence and is difficult to follow.
						</br>0 Response is too limited to assign a higher score and demonstrates no comprehension of the source text.
						
						</br>
						</br><span style='font-weight:bold;font-size:12pt;'>答题建议</span>在 PTE 的 Summarize Written Text（SWT）任务中，建议先在阅读阶段迅速识别文章的核心主题，并从全文中提炼约 四个主要观点 作为信息主干。随后将这四个关键点以逻辑顺序整合进 一条 5–75 词的单句总结 中，通过从句、连词和因果或递进关系将内容自然串联，同时保持语法结构完整、句式清晰且无冗余信息。写作完成后务必检查句子是否真正只有一个句号、词数符合要求、时态与拼写准确无误；这些技术性要求如果不满足，会直接影响内容与格式评分。因此，稳准提炼观点、清晰整合结构和严格遵守形式规范，是取得 SWT 高分的关键策略。`
					}
				}
				else if(type == 'gs'){
					this.descFont = {
						title: '格式',
						desc: `1 Is written in one, single, complete sentence
						</br>0 Not written in one, single, complete sentence or contains fewer than 5 or more than 75 words. Summary is written in capital letters
						</br>
						</br><span style='font-weight:bold;font-size:12pt;'>答题建议</span>在 SWT 中，“Form”（格式/形式）部分很关键。若格式不正确，即使内容正确，也可能被扣分或得零分。根据官方/主流辅导资料，应注意以下几点： 
一句话表达：答案必须是 一个完整、独立的句子 —— 只有一个句号（full stop）作为结尾，不能写成两句或更多句。 
字数限制：必须在 5–75 个单词（words） 之间。少于 5 个或多于 75 个都会导致 Form 得分为 0。 
首尾/大小写规范：句子首字母应大写，结尾要有句号；全文不要全部大写（即不要用全大写字母） —— 这是基础格式要求。
不要分行／列点／清单：不要把答案写成两个句子、子弹列点、短语堆砌或无标点的碎片。SWT 要求一个“stand-alone”句子。 
结构完整：这个句子应当包含主语 (subject) + 谓语 (verb) + 宾语或补充内容 (object / complement)，必要时可用从句 (subordinate clause) 或分号 (semicolon)／连词 (conjunction) 来串联信息，使其成为一个语法正确且逻辑完整的复合/复杂句。`
					}
				}
				else if(type == 'yf'){
					this.descFont = {
						title: '格式',
						desc: `2 Has correct grammatical structure
						</br>1 Contains grammatical errors but with no hindrance to communication
						</br>0 Has defective grammatical structure which could hinder communication
						</br>
						</br><span style='font-weight:bold;font-size:12pt;'>答题建议</span>在 SWT 中，Grammar 方面，要确保整个句子拥有清晰的 主语—谓语—宾语 结构，通过连词或从句将各个主要观点顺畅连接，避免出现时态混用、主谓不一致或重复标点等错误。练习平台的即时反馈能帮助你快速检查字数、句式完整性与语法准确性，从而稳定提升 SWT 写作表现。`
					}
				}
				else if(type == 'ch'){
					this.descFont = {
						title: '词汇',
						desc: `2 Has appropriate choice of words
						</br>1 Contains lexical errors but with no hindrance to communication
						</br>0 Has defective word choice which could hinder communication
						</br>
						</br><span style='font-weight:bold;font-size:12pt;'>答题建议</span>PTE 对于词汇的要求是 "appropriate choice of words"（合理的词语搭配）。是允许使用原文的，不用耗精力来替换词语。 `
					}
				}
				this.$store.commit("showaiDESCShow", true);
			},
			back() {
				this.$store.commit("showaiSwtShow", false);
				this.showbox = true
			},
		},
	}
</script>

<style lang="less" scoped>
	/deep/ .detailed_analysis h1{
		margin-top: 8px;
		font-weight: bold;
		font-size: 14px;
	}
	/deep/ .detailed_analysis strong{
		font-weight: bold;
		font-size: 12px;
	}
	/deep/ .detailed_analysis p{
		font-size: 12px;
		margin-top: 6px;
	}
</style>


// WEBPACK FOOTER //
// src/components/ai-swt.vue